/* eslint-disable import/no-unresolved */
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ShopProductSearch from "components/widgets/user/ShopProductSearch";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import * as Actions from "actions";
import {Chip, Container, IconButton, Typography} from "@mui/material";
import ShopHeaderMini from "components/elements/user/shops/ShopHeaderMini";
import {isMarketPlace} from "helpers/utils";
import ShopHeaderNav from "components/elements/user/shops/ShopHeaderNav";


const ShopProductPageSearch = (props) => {

    const {
        match, history,
        userResetSearchProducts, bootupInfo
    } = props;

    const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);


    const [state] = useState({
        layoutColumns: 3,
    });

    useEffect(() => {
        userResetSearchProducts();
        document.getElementById("color").setAttribute("href", "#");
    }, []);



    return (
        <div>
            <ShopHeaderNav history={history} />
            {isMarketPlace() && <ShopHeaderMini />}
            <ShopProductSearch {...props} shopId={shopId} isShop={true} colSize={state.layoutColumns} />
        </div>
    );
};

ShopProductPageSearch.defaultProps = {
  isLoading: false,
};

ShopProductPageSearch.propTypes = {
    userResetSearchProducts: PropTypes.func.isRequired,
    bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.object).isRequired,
};

const shopProductPageSearch = connect(
  ({  bootupInfo }) => ({
    bootupInfo,
      userDetails: bootupInfo.userDetails,
    reqStatus: bootupInfo.reqStatus,
    isLoading: bootupInfo.isLoading,
    serviceError: bootupInfo.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopProductPageSearch);

export default shopProductPageSearch;
